import { gql } from 'apollo-angular';

export const deleteAllProjectWageRatesMutation = gql`
  mutation deleteAllProjectWageRates($tenantId: UUID!, $legacyProjectId: Int!) {
    deleteProjectWageLegacy(
      legacyProjectId: $legacyProjectId
      tenantId: $tenantId
    ) {
      data {
        deleted
      }
      errors {
        message
      }
    }
  }
`;
